import { findBenefit, getclaim, getClaimSubscription, getEvents, getPaperAndDocument } from 'app/modules/claim/service';
import { getEvent, getUserInfoSelector } from 'app/modules/claim/service/store/selectors';
import { getSubscriptionsList } from 'app/modules/contract/service/store/selectors';
import { uploadDocuments } from 'app/modules/document/service';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { View } from 'app/modules/rules/domain/View';
import { getDataView } from 'app/modules/rules/service/rulesService';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import ConfComp from 'app/shared/components/common/conf-component';
import { IRootState } from 'app/shared/reducers';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { getClaimDetailsCmsData, getModalInformationButton } from 'app/modules/cms/service/store/selectors';
import { createContact, resetContact } from 'app/modules/contact/service';
import { hideGenerateBPError, hideGeolocalisationModal, resetBonTransport } from 'app/modules/logistic/service';
import ModalGenerateBpError from 'app/shared/components/common/modal/modal-generate-bp-error';
import ModalWithAction from 'app/shared/components/common/modal/modal-with-Action';
import ClaimDetailPageSkeleton from 'app/shared/components/skeleton/desktop/s-claim-detail-page';
import { Constraint } from 'app/shared/util/constraint';
import './style.scss';

export interface IClaimDetails {
  data: any;
}

export const ClaimDetailsPage = () => {
  const history = useHistory();
  const match: any = useRouteMatch();
  const { params } = match;
  const dispatchor = useDispatch();

  const uploadClaimDocsHandler = docs => {
    dispatchor(uploadDocuments(docs));
  };
  const [refEffect, setRefEffect] = useState(0);

  const userInfo: any = useSelector<IRootState>(getUserInfoSelector);
  const claimSelected: any = useSelector<IRootState>(state => state.claim.claimModel.claim);
  const loading: any = useSelector<IRootState>(state => state.claim.loading);
  const viewDataitems = useSelector(getDataViewRules(View.CLAIM_DETAIL_PAGE));
  const subscriptionSelected: any = useSelector<IRootState>(state => state.claim.claimModel.subscription);
  const EventInfo: any = useSelector<IRootState>(getEvent);
  const subscriptionList: any = useSelector(getSubscriptionsList);
  const listDocs: any = useSelector<IRootState>(state => state.document.documentModel.documentList);
  const listPaperAndDocs: any = useSelector<IRootState>(state => state.claim.claimModel.paperAndDocument);
  const loadingUpload: any = useSelector<IRootState>(state => state.document.loading);
  const defaultSellingPointCode: any = useSelector<IRootState>(state => state.sellingPoint?.connectedSellingPoint?.code);
  const contactForm: any = useSelector<IRootState>(state => state.contact.contactForm);
  const sellingPoint: any = useSelector<IRootState>(state => state.sellingPoint);
  const claim: any = useSelector<IRootState>(state => state.claim);
  const logistic: any = useSelector<IRootState>(state => state.logistic);
  const cmsLoading: any = useSelector<IRootState>(state => state.cms.loading);
  const cmsData: any = useSelector(getClaimDetailsCmsData);
  const sameSellingPoint = subscriptionList.find(el => el?.subscriptionNumber)?.sellingPoint?.sellingPointCode === defaultSellingPointCode;
  const { bonTransportError, geolocalisationModal }: any = useSelector<IRootState>(state => state.logistic);
  const contactLoading: any = useSelector<IRootState>(state => state.contact.loading);
  const modalInformation: any = useSelector(getModalInformationButton)

  const creatContact = contactInfo => dispatchor(createContact(contactInfo));

  const restContact = () => dispatchor(resetContact());
  useEffect(() => {
    dispatchor(getDocCMS('desktop_claim_details_costumer_v2'));
  }, []);

  useEffect(() => {
    const rulesContext: RulesContext = {
      key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
      entryDataRules: { view: View.CLAIM_DETAIL_PAGE, productCode: claimSelected?.product?.code },
    };
    dispatchor(getDataView(rulesContext));
  }, [claimSelected]);

  useEffect(() => {
    if (params?.claimNumber) {
      dispatchor(getclaim(params?.claimNumber));
    }
  }, []);

  useEffect(() => {
    setRefEffect(refEffect + 1);
  }, [claimSelected]);
  useEffect(() => {
    if (claimSelected?.claimNumber === params?.claimNumber && refEffect >= 1) {
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetClaimSubscription')) {
        dispatchor(getClaimSubscription(claimSelected?.subscriptionNumber));
      }

      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetEvents')) {
        dispatchor(getEvents('CLAIM', claimSelected?.claimNumber));
      }
      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetPaperAndDocument')) {
        dispatchor(getPaperAndDocument(claimSelected?.subscriptionNumber, claimSelected.claimNumber));
      }

      if (viewDataitems?.dataRecoveryService?.find(service => service === 'GetBenefit')) {
        dispatchor(resetBonTransport());
        dispatchor(findBenefit(claimSelected?.claimNumber));
      }
    }
  }, [claimSelected, viewDataitems]);

  function getConstrante(constraint, confValue) {
    return Constraint(
      constraint,
      {
        accountState: null,
        sellingPointState: sellingPoint,
        claimState: claim,
        docState: listPaperAndDocs,
        logisticState: logistic,
        eventState: EventInfo,
      },
      confValue
    );
  }

  const getBrand = (data: any) => {
    return (data?.damagedGoods[0] || [])?.brand;
  };

  const getModel = (data: any) => {
    return (data?.damagedGoods[0] || [])?.model;
  };


  return (
    <>
      {cmsLoading || contactLoading ? (
        <ClaimDetailPageSkeleton />
      ) : (
        <div>
          <div className="container-fluid contract-link"></div>
          <div className="container-fluid px-0 container-top">
            <div className="row pt-3 w-100 m-0">
              <div className="col-sm-12 col-lg-4 ">
                <div className="col-md-12 mb-3 px-0">
                  <ConfComp
                    code="USER_INFO_CLAIM"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      subscriptionSelected,
                      loading,
                      data: userInfo,
                      cmsData,
                    }}
                  />
                </div>

                <div className="col-md-12 mb-3 px-0">
                  <ConfComp
                    code="STORE_INFO_COMPONENT"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      data: userInfo,
                      claimSelected,
                      loading,
                      cmsData,
                    }}
                  />
                </div>
                <div className="col-md-12 mb-3 px-0">
                  <ConfComp
                    code="CLAIM_TIPS"
                    listCode={viewDataitems?.componentDataList}
                    props={{
                      loading,
                      cmsData,
                    }}
                  />
                </div>
              </div>
              <div className="col-sm-12 col-lg-8 mb-3 w-100 m0">
                <ConfComp
                  code="CLAIM_INFO_TAB"
                  listCode={viewDataitems?.componentDataList}
                  props={{
                    event: EventInfo,
                    data: claimSelected,
                    uploadClaim: uploadClaimDocsHandler,
                    subscriptionSelected,
                    userInfo,
                    itemToUpload: listDocs,
                    loading,
                    claimNumber: params?.claimNumber,
                    uploadLoading: loadingUpload,
                    sameSellingPoint,
                    contactForm,
                    creatContact,
                    restContact,
                    getConstrante,
                    cmsData,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalGenerateBpError
        message={[cmsData?.claim_recap_items?.modal_generate_bp_error]}
        modal={bonTransportError}
        setModal={() => dispatchor(hideGenerateBPError())}
        txtContactUsButton={cmsData?.claim_recap_items?.modal_degeolocalisation_error_contact_button}
        hideClose={true}
        contactUsButtonAction={() => history.push("/contact")}
      />
      <ModalGenerateBpError
        message={[cmsData?.claim_recap_items?.modal_geolocation_check_info]}
        modal={geolocalisationModal}
        setModal={() => dispatchor(hideGeolocalisationModal())}
      />
      <ModalWithAction
        showModal={contactForm}
        setShowModel={''}
        textBody={cmsData?.contact_tab?.contact_choice?.modal_messages?.modal_succes_message}
        icon={modalInformation?.Success_Icon?.url}
        action={() => {
          restContact();
        }}
        btnActionLabel={modalInformation?.CLOSE_button}
        
      />
    </>
  );
};
